import { render } from "./create-room.vue?vue&type=template&id=4dba6f86&scoped=true"
import script from "./create-room.vue?vue&type=script&lang=js"
export * from "./create-room.vue?vue&type=script&lang=js"

import "./create-room.vue?vue&type=style&index=0&id=4dba6f86&lang=scss&scoped=true"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dba6f86"]])

export default __exports__